export default __webpack_public_path__ + "static/media/2381.e44b4010.png";